// Lucide icon: chevron-down (https://lucide.dev/icons/chevron-down)
import { ChevronDown } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconChevronDown = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ChevronDown />
    </IconComponentStyled>
  )
}
